var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieContactOldStudent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205.6 171.7",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    transform: "translate(-1722.465 3510.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    fill: "#454545",
    d: "M1926.1-3470.6v-23.2c0-9.1-7.4-16.5-16.6-16.6h-50.8c-9.1,0-16.5,7.4-16.6,16.6v138.6 c0,9.1,7.4,16.5,16.6,16.6h50.8c9.1,0,16.5-7.4,16.6-16.6v-94c1.1-0.1,2-1,2-2.2v-17.1C1928.1-3469.6,1927.2-3470.5,1926.1-3470.6z  M1922.1-3355.2c0,6.9-5.6,12.6-12.6,12.6h-50.8c-6.9,0-12.5-5.6-12.6-12.6v-138.6c0-6.9,5.6-12.5,12.6-12.6h2.1v2.6 c0,2.6,2.1,4.7,4.7,4.7c0,0,0,0,0,0h37.1c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0v-2.6h2.1c6.9,0,12.6,5.6,12.6,12.6V-3355.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    fill: "#E3E3E3",
    d: "M1922.1-3493.8v138.6c0,6.9-5.6,12.6-12.6,12.6h-50.8c-6.9,0-12.5-5.6-12.6-12.6v-138.6 c0-6.9,5.6-12.5,12.6-12.6h2.1v2.6c0,2.6,2.1,4.7,4.7,4.7c0,0,0,0,0,0h37.1c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0v-2.6h2.1 C1916.5-3506.3,1922.1-3500.7,1922.1-3493.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    fill: "#FFFFFF",
    d: "M1846.2-3368.7v13.5c0,6.9,5.6,12.6,12.6,12.6h50.8c6.9,0,12.6-5.6,12.6-12.6v-13.5H1846.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    fill: "#FFFFFF",
    d: "M1908.9-3428.7h-49.4c-2.2,0-4.1,1.8-4.1,4.1c0,0,0,0,0,0v26c0,2.2,1.8,4.1,4.1,4.1h44.4 c1,0,1.9,0.4,2.6,1.1l4.6,4.6c0.4,0.4,1.1,0.4,1.5,0c0.2-0.2,0.3-0.5,0.3-0.8v-35.1C1913-3426.8,1911.1-3428.7,1908.9-3428.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    fill: "#FFFFFF",
    d: "M1859.5-3486.5h49.4c2.2,0,4.1,1.8,4.1,4.1c0,0,0,0,0,0v26c0,2.2-1.8,4.1-4.1,4.1 c0,0,0,0,0,0h-44.4c-1,0-1.9,0.4-2.6,1.1l-4.6,4.6c-0.4,0.4-1.1,0.4-1.5,0c-0.2-0.2-0.3-0.5-0.3-0.8v-35.1 C1855.4-3484.7,1857.2-3486.5,1859.5-3486.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_324"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722",
    x: 1862.3,
    y: -3403.8,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    x: 1862.3,
    y: -3408.9,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    x: 1862.3,
    y: -3414,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    x: 1862.3,
    y: -3419.1,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    x: 1862.3,
    y: -3461.7,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1727",
    x: 1862.3,
    y: -3466.8,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    x: 1862.3,
    y: -3471.9,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    x: 1862.3,
    y: -3476.9,
    fill: "#919191",
    width: 43.7,
    height: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1730",
    fill: "#E3E3E3",
    d: "M1854.4-3362.7h46.5c1.2,0,2.1,0.9,2.1,2.1v5.4c0,1.2-0.9,2.1-2.1,2.1h-46.5 c-1.2,0-2.1-0.9-2.1-2.1v-5.4C1852.3-3361.8,1853.3-3362.7,1854.4-3362.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    fill: "#79C48E",
    cx: 1911.4,
    cy: -3357.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    fill: "#E0C1A4",
    d: "M1821.2-3463c-0.9-0.7-1.1-2-0.3-3c0,0,0,0,0,0c1.6-2.6,4.2-4.4,2.6-7.9 c-0.2-0.4-1.1-1-1.9,0c-2.1,2.4-5.7,5.8-6.7,6.1c-1.5,0.5-1.2,1.1-15,1.1l2.4,5.8c11.4-1.7,12-2,13-2.2c2.1-0.6,5,1.5,6.6,2.5 c0.1-0.1,0.2-0.3,0.2-0.5C1822.2-3461.9,1821.7-3462.4,1821.2-3463z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_Standing_Skinny_Jeans"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Leg_00000062907912438768648950000014903176208311314078_",
    fill: "#454545",
    d: "M1773.7-3432.7l11.1,87h-7.6l-10.4-36.9 l-14.3-50.1H1773.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-2_00000157986932671892192800000003519751555827568802_",
    fill: "#757575",
    d: "M1773.7-3432.7 c-7,24.7-8.4,42.2-8.4,42.2s-1.8,16.8-9.7,44.8h-7.9c0.9-5.2,1.7-10.2,2.3-14.7c1.9-14.1,2-28.5,0.2-42.6 c-1.2-9.8-1.8-19.8-1.6-29.7L1773.7-3432.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left_Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe_00000000215600657816945370000001624486455076626347_",
    fill: "#191847",
    d: "M1751-3338.6v-0.8l5.1,0.8h15v-1.6 c0,0-9.5-2.6-15.4-6.7h-8.3l-0.4,8.3L1751-3338.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2_00000023989160935462262150000000600939953557769856_",
    fill: "#191847",
    d: "M1780-3338.6v-0.8l5.1,0.8h15v-1.6 c0,0-9.5-2.6-15.4-6.7h-8.3l-0.4,8.3L1780-3338.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Head_Front_Short_Beard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Head-2_00000016771586411509753830000013378847079253026706_",
    fill: "#E0C1A4",
    d: "M1773.7-3474.4l-1.6-11.3 c2.5,1.5,5.1,2.3,6.2,2c2.9-0.8,3.2-11.5,0.9-15.8s-14-6.1-14.6,2.3c-0.1,2.8,0.9,5.6,2.8,7.7l-3.3,15.2L1773.7-3474.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair_00000146486249652711604410000003240706412315603095_",
    fill: "#987F51",
    d: "M1772.6-3496.3c0.6-1.1,1.5-2,2.6-2.7 c4.2,0.1,4.6-0.7,4.6-3.2c-1.8-0.9-3.7-1.4-5.7-1.5c-1.5-0.4-3.1-0.3-4.5,0.3c-2,0.5-3.6,1.9-4.2,3.9c-2.6,4.4-0.6,9.1,2,10.7 c0.7-0.8,1.3-1.6,1.9-2.4c-0.5-0.4-0.7-1.1-0.7-1.7c0-1.3,1.1-2.4,2.4-2.4c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0 C1771.6-3495.2,1772.2-3495.7,1772.6-3496.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    fill: "#E0C1A4",
    d: "M1735.6-3439.5l-6.8,15.7c-2.4,2.4-4.5,5-6.2,8c-0.2,0.8-0.3,2.1,1.7,0.7s4.2-2.8,4.9-2.2 s-0.1,2.2,1.1,2.8c0.8,0.4,1.7-2.3,2.7-8.1l8.9-11.7L1735.6-3439.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back_00000170276898367474388150000014636592408717641901_",
    fill: "#79C48E",
    d: "M1787.9-3459.9 c6.9,2.2,10.8,2.9,24.7-1.4l-2.6-6.3c-4.4,0.2-8.9,0-13.3-0.8c-3.5-0.6-6.9-1.8-10-3.5c-4.2-2.4-9.4-5.5-15.8-9.3l-5.1,4.1 C1768.4-3465.4,1783-3461.5,1787.9-3459.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt_00000054945845204606165340000011945928344943932092_",
    fill: "#DDE3E9",
    d: "M1765.9-3483.5l8.7,1.4 c0,16.5,3.3,34.6,5.6,46.2c0.2,1,0.5,3-0.9,3l-24-1.5C1756.7-3453.6,1758.7-3471.9,1765.9-3483.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front_00000151530935217695228710000016850755456132851884_",
    fill: "#79C48E",
    d: "M1736.3-3426.4 c4.2-4.9,9.3-12.8,15.5-23.9c-1.9,6.5-3.1,13.2-3.7,20h27.1c5.2-13.3-6.4-53.2-6.4-53.2h-3.4c-19.5,12-23.2,26.3-35.3,55.9 L1736.3-3426.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1731",
    fill: "#325CA7",
    d: "M1857.8-3442h31.9c1.3,0,2.4,1.1,2.4,2.4l0,0c0,1.3-1.1,2.4-2.4,2.4h-31.9 c-1.3,0-2.4-1.1-2.4-2.4l0,0C1855.4-3440.9,1856.5-3442,1857.8-3442z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1732",
    fill: "#B14196",
    d: "M1881.6-3382.5h31.9c1.3,0,2.4,1.1,2.4,2.4l0,0c0,1.3-1.1,2.4-2.4,2.4h-31.9 c-1.3,0-2.4-1.1-2.4-2.4l0,0C1879.2-3381.4,1880.3-3382.5,1881.6-3382.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieContactOldStudent);
export default __webpack_public_path__ + "static/media/illustratie_contact_old_student.accd0ddd98b7ab7b8eda2157d9c2df4e.svg";
export { ForwardRef as ReactComponent };